import { randomUUID } from 'node:crypto';
export default { randomUUID };
